import { render, staticRenderFns } from "./ProductSizeList.vue?vue&type=template&id=65dd1114&scoped=true&"
import script from "./ProductSizeList.vue?vue&type=script&lang=js&"
export * from "./ProductSizeList.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizeList.vue?vue&type=style&index=0&id=65dd1114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd1114",
  null
  
)

export default component.exports